export default "__VITE_ASSET__6f69f4e3__"